import { getNodeIndex, getNodeParent } from "@/lib/tree/tree";
import { Tree, TreeNode } from "@/types/tree";
import { parseTreeId } from "@/lib/canvas/helpers";

export type DragPayload = {
  draggedElementId: TreeNode["id"];
  droppedOnElementId: TreeNode["id"];
  index: number;
};

export type MouseDragStatus = {
  overTopHalf: false | TreeNode["id"];
  overBottomHalf: false | TreeNode["id"];
  overIndex: false | TreeNode["id"];
  overNodeId: false | TreeNode["id"];
  overNodeParentId: false | TreeNode["id"];
  overNestDeeper: false | TreeNode["id"];
  overNestShallower: false | TreeNode["id"];
  overSelf: boolean;
};

export function initialMouseDragStatus(): MouseDragStatus {
  return {
    overTopHalf: false,
    overBottomHalf: false,
    overIndex: false,
    overNodeId: false,
    overNodeParentId: false,
    overSelf: false,
    overNestDeeper: false,
    overNestShallower: false
  };
}

export function getNodeIdAtPointInStructurePanel(x: number, y: number) {
  const draggedElement = document
    .elementsFromPoint(x, y)
    .filter(filterByClass("structure-node"))
    .sort(sortByDepth)
    .reverse()
    .pop();

  if (draggedElement) {
    // @ts-ignore
    const elementId = draggedElement.dataset.elementId;

    if (elementId) {
      return parseTreeId(elementId);
    }
  }

  return false;
}

export const filterByClass = (className: string) => {
  return (element: Element) => {
    if (element.classList.contains(className)) {
      return true;
    }
    return false;
  };
};

/* a bit fuckin brittle having the depth and other shit in the DOM... like... 
there's a bunch of shit related to drag that's simply in the DOM of the structure panel's HTML output
it works perfectly, but is there a better way? using DOM as a source of truth is sketchy */

export const sortByDepth = (elementA: Element, elementB: Element) => {
  // @ts-ignore
  if (parseInt(elementA.dataset.depth) > parseInt(elementB.dataset.depth)) {
    return -1;
  } else if (
    // @ts-ignore
    parseInt(elementB.dataset.depth) > parseInt(elementA.dataset.depth)
  ) {
    return 1;
  } else {
    return 0;
  }
};

const getElementIdDataAttrFromFirstElementThatMatchesClass = (
  elementsList: Element[],
  className: string
) => {
  const elements = elementsList.filter(filterByClass(className));
  if (elements.length > 0) {
    // @ts-ignore
    return parseTreeId(elements[0].dataset.elementId);
  }

  return false;
};

export const getMouseDragStatus = (
  mouseX: number,
  mouseY: number,
  tree: Tree
): MouseDragStatus => {
  const elementsList = document.elementsFromPoint(mouseX, mouseY); // TODO: needs slight tweak for Edge compatibility, function name is different and returns NodeList

  const dragStatus = initialMouseDragStatus();

  dragStatus.overNestDeeper =
    getElementIdDataAttrFromFirstElementThatMatchesClass(
      elementsList,
      "nest-deeper"
    );

  dragStatus.overNestShallower =
    getElementIdDataAttrFromFirstElementThatMatchesClass(
      elementsList,
      "nest-shallower"
    );

  dragStatus.overTopHalf = getElementIdDataAttrFromFirstElementThatMatchesClass(
    elementsList,
    "top-half"
  );

  dragStatus.overBottomHalf =
    getElementIdDataAttrFromFirstElementThatMatchesClass(
      elementsList,
      "bottom-half"
    );

  dragStatus.overSelf =
    getElementIdDataAttrFromFirstElementThatMatchesClass(
      elementsList,
      "breakdance--currently-dragging"
    ) !== false;

  if (dragStatus.overBottomHalf) {
    dragStatus.overNodeId = dragStatus.overBottomHalf;
  } else if (dragStatus.overTopHalf) {
    dragStatus.overNodeId = dragStatus.overTopHalf;
  }

  if (dragStatus.overNodeId) {
    const parent = getNodeParent(tree, dragStatus.overNodeId);
    const index = getNodeIndex(tree, dragStatus.overNodeId);

    if (index !== false && parent !== false) {
      dragStatus.overIndex = index;
      dragStatus.overNodeParentId = parent.id;
    }
  }

  return dragStatus;
};
